

/**
 * @name ClientsListController
 * @description Controller for the clients list component
 * @param {unknown} $state unknown
 * @param {object} Session The user session service
 * @param {object} Collector The user session service
 * @param {object} Appointments The Appointments service
 * @param {object} $uibModal The bootstrap modal service
 * @param {object} MergeProjects The MergeProjects service
 * @param {object} RESPONSE_MESSAGES The RESPONSE_MESSAGES constant
 * @param {object} AlertMessages The AlertMessages service
 * @param {unknown} _ The lodash service
 */
function ClientsListController(
  $state,
  Session,
  Collector,
  Appointments,
  $uibModal,
  MergeProjects,
  RESPONSE_MESSAGES,
  AlertMessages,
  _
) {
  let vm = this;

  // Public functions
  vm.updateClient = updateClient;
  vm.getClientAppointments = getClientAppointments;
  vm.resetSearch = resetSearch;
  vm.searchTermsUpdated = searchTermsUpdated;
  vm.uiOnParamsChanged = uiOnParamsChanged;
  vm.loadPage = loadPage;
  vm.session = Session;

  // Public variabls
  vm.loading = false;

  // Clients are loaded in the state resolve.

  // Load search parameters from the params in the state defintion.
  vm.search = {
    page: vm.$transition$.params().page,
    search: vm.$transition$.params().search
  };

  /**
   * @name updateClient
   * @description Function to update a client through a modal window
   * @param {object} client The client to edit
   */
  function updateClient(client) {
    let modalInstance = $uibModal.open({
      template: require('./update/update-client-modal.template.html'),
      animation: true,
      controller: 'UpdateClientModalController',
      bindToController: true,
      controllerAs: '$ctrl',
      resolve: {
        client: function() {
          return client;
        }
      }
    });
    modalInstance.result.then(
      function(client) {
        // Nothing to do
      },
      function() {
        AlertMessages.add({
          msg: RESPONSE_MESSAGES.closedWithoutSaving,
          type: 'warning'
        });
      }
    );
  }

  /**
 * @name getClientAppointments
 * @description
 * @param {number} client The client to view appointments
 */
  function getClientAppointments(client) {
    let modalInstance = $uibModal.open({
      template: require('./appointments/client-appointments-modal.template.html'),
      animation: true,
      controller: 'ClientAppointmentsModalController',
      bindToController: true,
      controllerAs: '$ctrl',
      resolve: {
        appointments: function() {
          // Set all variables to blank for the appointments service
          let collector = client.id;
          let search = false;
          let start;
          let end;
          let timestamp;
          let artist;
          return Appointments.get(search, start, end, timestamp, artist, collector)
          .then(function(appointments) {
            if (appointments.length > 0) {
              return MergeProjects.merge(appointments).then(function(mergedData) {
                appointments = mergedData;
                return appointments;
              });
            }
          });
        },
        client: function() {
          return client;
        }
      }
    });
    modalInstance.result.then(
      function() {
        // Nothing to do
      },
      function() {
        // Nothing to do
      }
    );
  }

/**
 * @name searchTermsUpdated
 * @description Function to update the URL parameters by calling $state.go.
 * '.' calls the current state and loads new params based on changes in the
 * view form.
 */
  function searchTermsUpdated() {
    vm.search.page = '1';
    $state.go('.', vm.search, {reload: true});
  }

/**
 * @name uiOnParamsChanged
 * @description A ui-router function callback when param values change.
 * @param {object} newParams The name of the param that changed and its new value
 */
  function uiOnParamsChanged(newParams) {
    _.assign(vm.search, newParams);
    if (!_.isUndefined(newParams.search)) {
      vm.search.page = '1';
    }
    $state.go('.', vm.search, {reload: true});
  }

/**
 * @name loadPage
 * @description Updates the page number in vm.search.page and calls $state.go to
 * update the URL with the new page number.
 * @param {number} page The new page number.
 */
  function loadPage(page) {
    vm.search.page = page.toString();
    $state.go('.', vm.search, {reload: true});
  }

/**
  * @name resetSearch
  * @description Remove the text input field value to trigger the watcher on
  * local variable
  */
  function resetSearch() {
    vm.search.search = '';
    vm.search.page = '1';
    $state.go('.', vm.search, {reload: true});
  }
}

angular
  .module('inkfinder')
  .controller('ClientsListController', ClientsListController);



// WEBPACK FOOTER //
// ./components/clients-list/clients-list.controller.js